import { createSelector } from '@reduxjs/toolkit';
import type { XYPosition } from 'reactflow';

import { SelectionPanelId } from './uiSlice';
import type { RootState } from '../../store';

const selectSlice = (state: RootState) => state.ui;

export const selectSelectionPanel = (
  state: RootState
): SelectionPanelId | null => state.ui.selectionPanel;

export const selectUserIsDraggingSelectionBox = (state: RootState): boolean =>
  state.ui.selectionDrag;

/** current center of viewport in reactflow "flow coordinates" */
export const selectFlowPositionCenter = (state: RootState): XYPosition =>
  state.ui.flowPositionCenter;

export const _selectZoom = (state: RootState): number => state.ui.flowZoom;

export const selectCurrentConnectionInProgress = createSelector(
  selectSlice,
  (state) => state.currentTimeConstraintConnectionInProgress
);

export const selectWorkflowIsSaved = createSelector(
  selectSlice,
  (slice): boolean => slice.isSaved
);

export const selectWorkflowIsDeleted = createSelector(
  selectSlice,
  (slice): boolean => slice.isDeleted
);

export const selectTaskDependenciesAreVisible = createSelector(
  selectSlice,
  (slice): boolean => slice.taskDependenciesAreVisible
);

export const selectNewlyCreatedTimeConstraintId = createSelector(
  selectSlice,
  (slice) => slice.newlyCreatedTimeConstraintId
);
